import React from "react";

interface PartnerLogo {
  name: string;
  src: string;
  width: number;
  height: number;
  className: string;
}

// Heights are optically sized (not uniform) so each logo carries similar
// visual weight: dense wordmarks render shorter, light wordmarks taller.
// Wide logos are sized by width (they run out of height first); tall logos by height.
// Order alternates wide/tall so neighbouring shapes differ.
const partners: PartnerLogo[] = [
  {
    name: "HealthPartners",
    src: "/images/partners/healthpartners.svg",
    width: 300,
    height: 48,
    className: "w-full max-w-[220px] lg:max-w-[220px] h-auto max-h-20 lg:max-h-24",
  },
  {
    name: "PACE Southeast Michigan",
    src: "/images/partners/pace-southeast-michigan.webp",
    width: 70,
    height: 88,
    className: "w-auto max-h-20 lg:max-h-24",
  },
  {
    name: "PACE CNY",
    src: "/images/partners/pace-cny.webp",
    width: 260,
    height: 32,
    className: "w-full max-w-[200px] lg:max-w-[250px] h-auto max-h-16 lg:max-h-20",
  },
  {
    name: "Optum",
    src: "/images/partners/optum.svg",
    width: 260,
    height: 75,
    className: "w-full max-w-[200px] lg:max-w-[250px] h-auto max-h-16 lg:max-h-20",
  },
  {
    name: "PARClife",
    src: "/images/partners/parclife.webp",
    width: 88,
    height: 88,
    className: "w-auto max-h-20 lg:max-h-24",
  },
  {
    name: "Northeast Iowa Area Agency on Aging",
    src: "/images/partners/neia-aaa.webp",
    width: 165,
    height: 56,
    className: "w-full max-w-[180px] lg:max-w-[210px] h-auto max-h-20 lg:max-h-24",
  },
  {
    name: "LIFE VieCare",
    src: "/images/partners/life-viecare.webp",
    width: 74,
    height: 72,
    className: "w-auto max-h-16 lg:max-h-20",
  },
  {
    name: "Total Senior Care",
    src: "/images/partners/total-senior-care.webp",
    width: 144,
    height: 72,
    className: "w-auto max-h-16 lg:max-h-20",
  },
];

export function PartnerLogosSection() {
  return (
    <section className="group w-full bg-warm py-6 overflow-hidden" aria-labelledby="partner-logos-heading">
      <div className="text-center mb-4">
        <span id="partner-logos-heading" className="text-caption text-muted-foreground uppercase">
          Our Partners
        </span>
      </div>
      <div className="relative w-full">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-warm to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-warm to-transparent z-10" />

        <div className="flex items-center w-max animate-marquee group-hover:[animation-play-state:paused] motion-reduce:animate-none motion-reduce:w-full motion-reduce:justify-center">
          {partners.map((partner) => (
            <div
              key={partner.name}
              className="flex items-center justify-center px-10 lg:px-14 min-w-[180px] lg:min-w-[240px] h-24 lg:h-28"
            >
              <img
                src={partner.src}
                alt={partner.name}
                width={partner.width}
                height={partner.height}
                className={`object-contain opacity-80 hover:opacity-100 transition-opacity ${partner.className}`}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
          {partners.map((partner) => (
            <div
              key={`${partner.name}-duplicate`}
              aria-hidden="true"
              className="flex items-center justify-center px-10 lg:px-14 min-w-[180px] lg:min-w-[240px] h-24 lg:h-28"
            >
              <img
                src={partner.src}
                alt=""
                width={partner.width}
                height={partner.height}
                className={`object-contain opacity-80 hover:opacity-100 transition-opacity ${partner.className}`}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
